import cartFragmentMain from './cartFragment.main'

export default cartFragmentMain
